import { Box, Text, Title } from '@mantine/core';
import { Image } from '@unpic/react';
import cx from 'clsx';
import { ReactNode, useEffect } from 'react';

import { fonts } from 'shared/fonts';
import { vars } from 'shared/utils/ui/vars';

import classes from './PageMessage.module.scss';

type PageMessageProps = {
  title: string;
  description?: string;
  image: string | { src: string };
  imageAlt: string;
  footer?: ReactNode;
  isFullHeight?: boolean;
};

export function PageMessage(props: PageMessageProps) {
  const { title, description, image, imageAlt, footer } = props;

  useEffect(() => {
    document.documentElement.className = cx(fonts.map(font => font.variable));
  }, []);

  return (
    <Box className={cx(classes.pageContainer, { [classes.fullHeight]: props.isFullHeight })}>
      <Box className={classes.messageContainer} style={{ fontFamily: vars.other.fonts.bodyText.fontFamily }}>
        <Box className={classes.textContainer}>
          <Title order={1} className={classes.title}>
            {title}
          </Title>
          {description && <Text className={classes.description}>{description}</Text>}
        </Box>
        <Box className={classes.imageContainer}>
          <Image
            src={typeof image === 'string' ? image : image.src}
            alt={imageAlt}
            className={classes.image}
            layout="fullWidth"
          />
        </Box>
        {footer}
      </Box>
    </Box>
  );
}
